import {
  createSystem,
  defaultConfig,
  defineConfig,
  defineTokens,
} from "@chakra-ui/react";
import { buttonRecipe } from "./components/Button/button.recipe";
// import { accordionRootRecipe, accordionItemTriggerRecipe } from "./components/Accordion/accordion.recipe";
// import { dialogHeaderRecipe, dialogContentRecipe } from "./components/Dialog/dialog.recipe";
// import { tabsListRecipe, tabsTriggerRecipe } from "./components/Tabs/tabs.recipe";

const tokens = defineTokens({
  fonts: {
    body: { value: `'Raleway', sans-serif` },
    heading: { value: `'Raleway', sans-serif` },
    tooltip: { value: `'Open Sans', sans-serif` },
  },
  colors: {
    primary: { value: "#023648" },
  },
});

export const config = defineConfig({
  disableLayers: true,
  theme: {
    tokens,
    recipes: {
      Button: buttonRecipe,
      // AccordionRoot: accordionRootRecipe,
      // AccordionItemTrigger: accordionItemTriggerRecipe,
      // DialogHeader: dialogHeaderRecipe,
      // DialogContent: dialogContentRecipe,
      // TabsList: tabsListRecipe,
      // TabsTrigger: tabsTriggerRecipe,
    },
  },
});

const system = createSystem(defaultConfig, config);

export default system;
